// 14 allergeni obbligatori secondo il Regolamento UE 1169/2011 (allegato II).
// Codici brevi per etichette compatte nel menu.

export const ALLERGENS = {
  glutine:    { code: "G",  label: "Glutine",       full: "Cereali contenenti glutine (grano, orzo, avena, segale, farro, kamut)" },
  crostacei:  { code: "C",  label: "Crostacei",     full: "Crostacei e prodotti a base di crostacei" },
  uova:       { code: "U",  label: "Uova",          full: "Uova e prodotti a base di uova" },
  pesce:      { code: "P",  label: "Pesce",         full: "Pesce e prodotti a base di pesce" },
  arachidi:   { code: "A",  label: "Arachidi",      full: "Arachidi e prodotti a base di arachidi" },
  soia:       { code: "S",  label: "Soia",          full: "Soia e prodotti a base di soia" },
  latte:      { code: "L",  label: "Latte",         full: "Latte e prodotti a base di latte (compreso lattosio)" },
  fruttaguscio:{code: "FG", label: "Frutta a guscio", full: "Frutta a guscio (mandorle, nocciole, noci, pistacchi ecc.)" },
  sedano:     { code: "SD", label: "Sedano",        full: "Sedano e prodotti a base di sedano" },
  senape:     { code: "SN", label: "Senape",        full: "Senape e prodotti a base di senape" },
  sesamo:     { code: "SE", label: "Sesamo",        full: "Semi di sesamo e prodotti a base di sesamo" },
  solfiti:    { code: "SO", label: "Solfiti",       full: "Anidride solforosa e solfiti > 10 mg/kg" },
  lupini:     { code: "LU", label: "Lupini",        full: "Lupini e prodotti a base di lupini" },
  molluschi:  { code: "M",  label: "Molluschi",     full: "Molluschi e prodotti a base di molluschi" },
};

export const ALLERGEN_LIST = Object.keys(ALLERGENS);
